export default __webpack_public_path__ + "static/proudandtorn-edf64ecacb9c2219015d1ed2c9b17974.png";